import React from 'react'
import './mainDatePicker.scss'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { colors } from '../../../constants/colors';
function MainDatePicker ( { title, required = false, ...props } )
{
    return (
        <div className='mainDatePicker'>
            <div className='title'>{ `${ title }${ required ? '*' : '' }` }</div>
            <LocalizationProvider dateAdapter={ AdapterMoment }>
                <DatePicker
                    className='picker'
                    slotProps={
                        {
                            textField:
                            {
                                fullWidth: true,
                                size: 'small'
                            },
                            desktopPaper: {
                                sx: {
                                    "& .MuiPickersYear-yearButton":{
                                        "&.Mui-selected": {
                                            backgroundColor: colors.primaryColor,
                                        },
                                    },
                                    "& .MuiPickersDay-root": {
                                        "&.Mui-selected": {
                                            backgroundColor: colors.primaryColor +' !important',
                                        },
                                    },
                                    "& .MuiMenuItem-root": {
                                        "&.Mui-selected": {
                                            backgroundColor: colors.primaryColor,
                                        },
                                    },
                                    "& .MuiButton-root": {
                                        color: colors.primaryColor
                                    }
                                }
                            },
                            mobilePaper: {
                                sx: {
                                    "& .MuiPickersYear-yearButton": {
                                        "&.Mui-selected": {
                                            backgroundColor: colors.primaryColor,
                                        },
                                    },
                                    "& .MuiPickersDay-root": {
                                        "&.Mui-selected": {
                                            backgroundColor: colors.primaryColor,
                                            "&:hover": {
                                                backgroundColor: colors.primaryColor,
                                            }
                                        },
                                    },
                                    "& .MuiMenuItem-root": {
                                        "&.Mui-selected": {
                                            backgroundColor: colors.primaryColor,
                                        },
                                    },
                                    "& .MuiPickersYear-yearButton": {
                                        "&.Mui-selected": {
                                            backgroundColor: colors.primaryColor,
                                        },
                                    },
                                    "& .MuiButton-root": {
                                        color: colors.primaryColor
                                    },
                                    "& .MuiTab-root": {
                                        color: colors.primaryColor,
                                        "&.Mui-selected": {
                                            color: colors.primaryColor,
                                        },
                                    },
                                    "& .MuiTabs-indicator": {
                                        backgroundColor: colors.primaryColor
                                    },
                                    "& .MuiClock-pin": {
                                        backgroundColor: colors.primaryColor,
                                    },
                                    "& .MuiClockPointer-root": {
                                        backgroundColor: colors.primaryColor,
                                    },
                                    "& .MuiClockPointer-thumb": {
                                        backgroundColor: colors.primaryColor,
                                        borderColor: colors.primaryColor,
                                    },
                                }
                            }
                        } }
                    { ...props }
                />
            </LocalizationProvider>
        </div>
    )
}

export default MainDatePicker